import { render, staticRenderFns } from "./DetailHeaderCard.vue?vue&type=template&id=1309a300&scoped=true"
import script from "./DetailHeaderCard.vue?vue&type=script&lang=js"
export * from "./DetailHeaderCard.vue?vue&type=script&lang=js"
import style0 from "./DetailHeaderCard.vue?vue&type=style&index=0&id=1309a300&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1309a300",
  null
  
)

export default component.exports